export default "__VITE_ASSET__CiXiX$sc__"